import { URL_PARAMS } from "./const/URL_PARAMS";
import { getValidatedParamValue } from "./validateAndFormatParamValue";
function utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
}
function b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
}
export const getSearchParamValues = (shouldEncode = true) => {
    const allSearchParams = new URLSearchParams(window.location.search);
    const isEncoded = allSearchParams.get("capture_data");
    if (isEncoded) {
        try {
            const res = JSON.parse(b64_to_utf8(isEncoded));
            return res;
        }
        catch (_a) {
            return {};
        }
    }
    const result = URL_PARAMS.reduce((res, key) => {
        const value = allSearchParams.get(key);
        allSearchParams.delete(key);
        const validated = getValidatedParamValue(key, value);
        if (validated !== null) {
            return Object.assign(Object.assign({}, res), { [key]: validated });
        }
        return res;
    }, {});
    if (shouldEncode) {
        try {
            const encoded = utf8_to_b64(JSON.stringify(result));
            allSearchParams.set("capture_data", encoded);
            window.location.search = allSearchParams.toString();
        }
        catch (_b) { }
    }
    return result;
};
